export class BackupPermissions {

  public canDownloadBackup: boolean;
  public realTimeSchedulingAvailable: boolean;
  public canManageBackupSettings: boolean;
  public canManageRestoreSettings: boolean;
  public storage: number;
  public storageUnit: string;

}

export class ImageOptimizerPermissions {

  public extremeModeAvailable: boolean;
  public autoOptimizationAvailable: boolean;
  public limit: number;

}

export class Permissions {

  public canViewContent: boolean;
  public canManageContent: boolean;

  public backup: BackupPermissions;
  public imageOptimizer: ImageOptimizerPermissions;

}
